import { UpdateAccessibilitySettingsQueryArg } from '../types/query-arg';
import { UpdateAccessibilitySettingsQueryBody } from '../types/query-body';

export const updateAccessibilitySettingsQueryBody = ({
  organisation,
  accessibility,
}: UpdateAccessibilitySettingsQueryArg): UpdateAccessibilitySettingsQueryBody => ({
  organisationId: organisation.id,
  accessibility,
});
